<template>
  <div
    v-if="
      projetAnnuel.statut !== 'INSTRUCTION_EN_COURS' &&
      projetAnnuel.statut !== 'INSTRUCTION_TERMINEE' &&
      projetAnnuel.statut !== 'EN_ATTENTE'
    "
    class="projet-part"
  >
    <h2>
      {{ $t(`projet.labellise.result.titre${renewalSuffix}`) }}
    </h2>

    <fieldset>
      <legend v-if="projetAnnuel.statut === 'EN_ATTENTE'">
        {{ $t(`projet.labellise.result.saisi${renewalSuffix}`) }}
      </legend>
      <legend v-else>
        <span v-if="projetAnnuel.statut === 'ACCEPTE'">
          {{ $t(`projet.labellise.result.accepte${renewalSuffix}`) }}
        </span>
        <span v-else-if="projetAnnuel.statut === 'LABELLISATION_EN_DEVENIR'">
          {{ $t(`projet.labellise.result.en-devenir${renewalSuffix}`) }}
        </span>
        <span v-else-if="projetAnnuel.statut === 'REFUSE'">
          {{ $t(`projet.labellise.result.refuse${renewalSuffix}`) }}
        </span>
      </legend>
      <div v-if="projetAnnuel.evaluationFinale">
        <b>{{ $t("projet.labellise.result.instructeur-commentaire") }}</b
        ><br />
        <span
          v-html="projetAnnuel.evaluationFinale.commentaireInstructeur.replace('\n', '<br/>')"
        />
      </div>
    </fieldset>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue"

import { ProjetAnnuelDTO } from "@/model/bean/GeneratedDTOs"

export default defineComponent({
  name: "LabellisationResult",
  props: {
    projetAnnuel: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    renewalSuffix: {
      type: String,
      default: "",
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

.presentation-container {
  display: flex;
  justify-content: space-between;

  .presentation-explanations {
    padding-right: 20px;
    //padding-top: 50px;
    .explanation-bloc {
      padding-bottom: 30px;
      display: flex;

      .explanation-bloc-pic {
        padding-left: 10px;
        width: 70px;
      }

      .explanation-bloc-text {
        width: calc(38vw - 80px);
        text-align: justify;
        text-justify: distribute;
      }
    }

    .toggle-validation {
      border: 2px solid $bookmarkcard-border-color;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: auto;
      height: 7vw;

      .toggle-validation-text {
        span {
          display: inline-block;
          vertical-align: middle;
          line-height: normal;
          font-weight: bolder;
          margin: auto;
        }

        padding-right: 15px;
      }
    }
  }

  .presentation-recap {
    height: auto;

    .recap {
      width: auto;

      .BookmarkCard-card {
        width: auto;
        height: auto;
      }

      .BookmarkCard-content {
        height: auto;
        padding: 20px;
      }

      .BookmarkCard-icon {
        margin-top: 0 !important;
      }

      .section-in-error {
        font-size: 17px;
        padding-bottom: 20px;
      }

      .section-errors-link {
        span {
          color: $ofb-bleu-2;
        }

        &:hover {
          span {
            font-weight: bolder;
            color: $ofb-bleu-1;
          }
        }
      }

      .invalid-text {
        width: auto;
        display: block;
      }

      .field-in-error {
        font-size: 15px;
        padding-left: 10px;
        padding-top: 10px;

        a {
          color: black;

          &:hover {
            color: $red-errors;
            font-weight: bolder;
          }
        }

        .error-circle {
          border-radius: 50%;
          display: block;
          width: 22px;
          height: 22px;
          background-color: $red-errors;
          float: left;
          margin-left: 5px;
          margin-right: 5px;

          span {
            color: white;
            font-weight: bolder;
            padding-left: 6px;
            margin-right: 6px;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
